import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Create } from "adminApi/CustomersApi/Customers";
import { validateForm } from "utils/validation";
import { CustomersRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddCustomerForm from "./Componates/AddCustomerForm";
import fields from "../json/CustomersFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddCustomer = () => {
  const navigate = useNavigate();

  // Dynamically extract all form fields from any group except tabledata
  const allFields = useMemo(
    () => Object.keys(fields).filter((k) => k !== "tabledata").flatMap((k) => fields[k] || []),
    []
  );

  const fileFieldNames = useMemo(
    () => allFields.filter((f) => f.type === "file").map((f) => f.name),
    [allFields]
  );

  const initialValues = useMemo(() => {
    const init = allFields.reduce((acc, field) => {
      acc[field.name] = field.type === "switch" ? field.ValueOne || "active" : "";
      return acc;
    }, {});
    if (!init.country_dial_code) init.country_dial_code = "+91";
    return init;
  }, [allFields]);

  const { values, errors, handleChange, handleFileChange, setErrors } =
    useFormChange(initialValues, CustomersRules);

  const filePreviews = useMemo(() => {
    return fileFieldNames.reduce((acc, name) => {
      acc[name] = values[`${name}Preview`] || values[name];
      return acc;
    }, {});
  }, [fileFieldNames, values]);

  const cleanValues = (vals) => {
    const cleaned = { ...vals };
    fileFieldNames.forEach((name) => {
      delete cleaned[`${name}Preview`];
    });
    return cleaned;
  };

  const convertDateToMySQL = (date) => {
    if (!date) return null;

    const [day, month, year] = date.split("-");

    return `${year}-${month}-${day}`;
  };

  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const cleanedValues = cleanValues(formValues);
      const formData = new FormData();
      Object.entries(cleanedValues).forEach(([key, val]) => {
        if (val instanceof File) {
          formData.append(key, val);
        } else if (val !== null && val !== undefined) {
          if (key == "dob") {
            formData.append(key, convertDateToMySQL(val));
          } else {
            formData.append(key, String(val));
          }
        }
      });
      return await Create({ data: formData });
    },
    (vals) => {
      const cleanedValues = cleanValues(vals);
      const err = validateForm(cleanedValues, CustomersRules);
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Customer Created successfully!"
  );

  return (
    <>
      {loadingSubmit && <Spinner isSpinner={true} />}
      <AddCustomerForm
        fields={fields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        handleFileChange={handleFileChange}
        title="Create Customer"
        filePreviews={filePreviews}
      />
    </>
  );
};

export default AddCustomer;